export const COOKIE_CART_ID_KEY = 'hyperdrive-cart';
export const COOKIE_CART_ID_EXPIRE = 30;
export const CART_SOURCE = 'website';
export const DEALER_CART_SHARED_ID = 'dealerCartSharedId';
export const EXTERNAL_CUSTOMER_ID = 'customerId';
export var CartAction;
(function (CartAction) {
    CartAction["ADD_LINE_ITEM"] = "addLineItem";
    CartAction["REMOVE_LINE_ITEM"] = "removeLineItem";
    CartAction["SET_SHIPPING_METHOD"] = "setShippingMethod";
    CartAction["CHANGE_LINE_ITEM_QUANTITY"] = "changeLineItemQuantity";
    CartAction["ADD_DISCOUNT_CODE"] = "addDiscountCode";
    CartAction["REMOVE_DISCOUNT_CODE"] = "removeDiscountCode";
})(CartAction || (CartAction = {}));
export var CartState;
(function (CartState) {
    CartState["ACTIVE"] = "Active";
    CartState["ORDERED"] = "Ordered";
})(CartState || (CartState = {}));
export var ShippingMethodName;
(function (ShippingMethodName) {
    ShippingMethodName["HOME_DELIVERY"] = "Home delivery";
    ShippingMethodName["DELIVER_AT_DEALER"] = "Dealer delivery";
    ShippingMethodName["RETURN_BOX_HOME_DELIVERY"] = "Return box home delivery";
    ShippingMethodName["RETURN_BOX_DEALER_DELIVERY"] = "Return box dealer delivery";
    ShippingMethodName["UNITS_HOME_DELIVERY"] = "Units home delivery";
    ShippingMethodName["UNITS_DEALER_DELIVERY"] = "Units dealer delivery";
    ShippingMethodName["ELECTRO_BIKES_HOME_DELIVERY"] = "eBikes home delivery";
    ShippingMethodName["ELECTRO_BIKES_DEALER_DELIVERY"] = "eBikes dealer delivery";
})(ShippingMethodName || (ShippingMethodName = {}));
export const ShippingMethodsGroups = {
    HOME: [
        ShippingMethodName.HOME_DELIVERY,
        ShippingMethodName.RETURN_BOX_HOME_DELIVERY,
        ShippingMethodName.UNITS_HOME_DELIVERY,
        ShippingMethodName.ELECTRO_BIKES_HOME_DELIVERY,
    ],
    DEALER: [
        ShippingMethodName.DELIVER_AT_DEALER,
        ShippingMethodName.RETURN_BOX_DEALER_DELIVERY,
        ShippingMethodName.UNITS_DEALER_DELIVERY,
        ShippingMethodName.ELECTRO_BIKES_DEALER_DELIVERY,
    ],
};
export var CartErrorMessage;
(function (CartErrorMessage) {
    CartErrorMessage["NO_STOCK_LEFT"] = "NO_STOCK_LEFT";
    CartErrorMessage["NOT_ENOUGH_STOCK_LEFT"] = "NOT_ENOUGH_STOCK_LEFT";
    CartErrorMessage["PRODUCT_CANNOT_BE_ADDED"] = "PRODUCT_CANNOT_BE_ADDED";
    CartErrorMessage["CART_GROUP_INCOMPATIBLE"] = "CART_GROUP_INCOMPATIBLE";
    CartErrorMessage["CART_UPDATE_FAILED"] = "CART_UPDATE_FAILED";
    CartErrorMessage["PROMOCODE_NOT_FOUND"] = "PROMOCODE_NOT_FOUND";
    CartErrorMessage["PROMOCODE_IS_NOT_ACTIVE"] = "PROMOCODE_IS_NOT_ACTIVE";
    CartErrorMessage["PROMOCODE_ALREADY_APPLIED_TO_CART"] = "PROMOCODE_ALREADY_APPLIED_TO_CART";
    CartErrorMessage["PROMOCODE_NOT_AVAILABLE_IN_CART"] = "PROMOCODE_NOT_AVAILABLE_IN_CART";
    CartErrorMessage["PROMOCODE_IS_NOT_APPLICABLE"] = "PROMOCODE_IS_NOT_APPLICABLE";
})(CartErrorMessage || (CartErrorMessage = {}));
export var TypeId;
(function (TypeId) {
    TypeId["SHIPPING_METHOD"] = "shipping-method";
})(TypeId || (TypeId = {}));
// eslint-disable-next-line no-template-curly-in-string
export const CART_ID_SEPARATOR = '${id}';
export const PRODUCT_DELIVER_AT_DEALER_ONLY = 'productDeliverAtDealerOnly';
export const HOSTETTLER_ERROR_STATES = {
    SUCCESS_STATUS: '00',
    ERROR_SERVER: '01',
    ERROR_NOT_POSSIBLE_TO_ADD_THIS_QUANTITY: '02',
    ERROR_TOO_MANY_ITEMS_OF_THE_SAME_PRODUCT: '03',
    ERROR_TOO_MANY_TOTAL_ITEMS_IN_CART: '04',
};
export const PAYMENT_LINK_PROVIDER = 'paymentProviderLink';
export const FINANCING_ENABLED = 'financingEnabled';
export const LEASING_ENABLED = 'leasingEnabled';
